export default "__VITE_ASSET__D13Q0ejl__"